import React from "react";
import { useLang, useSettings, cldUrl } from "../lib/providers";

export default function TrustLogos() {
  const { lang } = useLang();
  const { settings } = useSettings();

  if (settings.trust_logos_enabled === false) return null;
  const logos = (settings.trust_logos || []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  if (logos.length === 0) return null;

  const title = lang === "ar" ? settings.trust_logos_title_ar : settings.trust_logos_title_fr;

  return (
    <section className="py-12 sm:py-16 border-t border-white/5" data-testid="trust-logos-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {title && (
          <p className="text-center text-[11px] font-bold tracking-[0.25em] uppercase text-white/40 mb-8" data-testid="trust-logos-title">
            {title}
          </p>
        )}
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10" data-testid="trust-logos-list">
          {logos.map((logo, i) => {
            const img = (
              <img
                src={cldUrl(logo.url, { w: 200, h: 80, c: "fit" })}
                alt={logo.alt || `logo-${i}`}
                className="h-8 sm:h-10 w-auto object-contain opacity-60 hover:opacity-100 grayscale hover:grayscale-0 transition-all duration-300"
                loading="lazy"
                decoding="async"
              />
            );
            return logo.link ? (
              <a key={logo.id || i} href={logo.link} target="_blank" rel="noreferrer" data-testid={`trust-logo-${i}`}>
                {img}
              </a>
            ) : (
              <div key={logo.id || i} data-testid={`trust-logo-${i}`}>{img}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
